export default {
  config: {},
  poster: {},
  support: {},
  contactUs: {},
  aboutUs: {},
  socialNetwork: [],
  menu: [],

  slides: [],
  services: [],
  servicesById: [],

  tutorials: [],
  tutorialsPage: [],
  tutorial: [],
  tutorialsPageTotal: [],
  relatedTutorials: [],

  categories: [],
  loadBtn: false,

  galleries: [],
  galleryPage: [],
  gallery: [],
  galleryList: [],
  galleryListImage1: [],
  galleryPageTotal: [],

  products: [],
  productsHome: [],
  productsPage: [],
  product: [],
  productsPageTotal: [],
  relatedProducts: [],

  blogs: [],
  relatedBlogs: [],
  blogHome: [],
  blogsPage: [],
  blogsPageTotal: [],
  blog: [],
  comments: [],
  newsLetters: [],
  rules: {},

  activityFields: [],
  province: [],
  city: [],
  customerOpinion: [],
  customerBanners: [],
  team: [],
  poolSessions: [],
};
